import { useEffect, useState } from 'react'
import './AnnouncementBanner.css'

const BANNER_ANIMATION_DURATION_MS = 9000
const JP_MESSAGE_START_MS = 4320
const EN_MESSAGE_RETURN_MS = 8640

const bannerMessages = [
  {
    lang: 'en',
    href: '/newsroom/bybeit-is-pivoting',
    content: (
      <>
        <span className="banner-message-strong">Bybeit has Pivoted</span>
        <span className="banner-message-light">— A company update</span>
      </>
    ),
  },
  {
    lang: 'ja',
    href: 'https://bybeit.app/newsroom/bybeit-is-pivoting-jp',
    content: (
      <>
        <span>バイバイトは</span>
        <span className="banner-message-semibold">日本市場エントリーコンサルティング</span>
        <span>事業へとピボットを行いました</span>
      </>
    ),
  },
]

export default function AnnouncementBanner() {
  const [activeMessageIndex, setActiveMessageIndex] = useState(0)

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return undefined
    }

    const syncLinkDestination = () => {
      setActiveMessageIndex(0)

      const showJapaneseMessage = window.setTimeout(() => {
        setActiveMessageIndex(1)
      }, JP_MESSAGE_START_MS)

      const returnToEnglishMessage = window.setTimeout(() => {
        setActiveMessageIndex(0)
      }, EN_MESSAGE_RETURN_MS)

      return [showJapaneseMessage, returnToEnglishMessage]
    }

    let activeTimeouts = syncLinkDestination()
    const cycleInterval = window.setInterval(() => {
      activeTimeouts.forEach((timeout) => window.clearTimeout(timeout))
      activeTimeouts = syncLinkDestination()
    }, BANNER_ANIMATION_DURATION_MS)

    return () => {
      activeTimeouts.forEach((timeout) => window.clearTimeout(timeout))
      window.clearInterval(cycleInterval)
    }
  }, [])

  return (
    <a
      className="announcement-banner"
      href={bannerMessages[activeMessageIndex].href}
      role="banner"
      aria-label="Bybeit has Pivoted — A company update / バイバイトは日本市場エントリーコンサルティング事業へとピボットを行いました"
    >
      <span className="banner-text" aria-hidden="true">
        <span className="banner-message-track">
          {[...bannerMessages, bannerMessages[0]].map((message, index) => (
            <span
              className="banner-message"
              lang={message.lang}
              key={`${message.lang}-${index}`}
            >
              {message.content}
            </span>
          ))}
        </span>
      </span>
    </a>
  )
}
